export type ConstantType = 'APPLICATION_NAME' |
    'PIWIK_URL' |
    'PIWIK_TRACKING_ID' |
    'version' |
    'apiUrl' |
    'preferredLocale' | 
    'showCustomTranslatorTemplate' |
    'preferredLogoUrl' |
    'supportUrl' |
    'privacyPolicyUrl';

export class Constants {
    static readonly applicationName: ConstantType = 'APPLICATION_NAME';
    static readonly piwikUrl: ConstantType = 'PIWIK_URL';
    static readonly piwikTrackingId: ConstantType = 'PIWIK_TRACKING_ID';
    static readonly version: ConstantType = 'version';
    static readonly apiUrl: ConstantType = 'apiUrl';
    static readonly preferredLocale: ConstantType = 'preferredLocale';
    static readonly showCustomTranslatorTemplate: ConstantType = 'showCustomTranslatorTemplate';
    static readonly preferredLogoUrl: ConstantType = 'preferredLogoUrl';
    static readonly supportUrl: ConstantType = 'supportUrl';
    static readonly privacyPolicyUrl: ConstantType = 'privacyPolicyUrl';
}



// WEBPACK FOOTER //
// ./src/models/Constants.ts